/* @flow */
import React from 'react';
import AddButton from 'components/AddButton.jsx';
import ClassCardView from 'settings/components/ClassCardView.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Group from 'entities/Group';
import Legend from 'components/Legend.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';

import './styles/ClassCardSection.scss';

class ClassCardSection extends React.Component {
  static propTypes = {
    items: React.PropTypes.arrayOf(React.PropTypes.instanceOf(Group)).isRequired,
    label: React.PropTypes.string.isRequired,
    addEnabled: React.PropTypes.bool,
    addModal: React.PropTypes.element,
    addText: React.PropTypes.string,
  };

  static defaultProps = {
    addEnabled: true,
    addText: 'Add class',
  }

  renderAddButton() {
    return this.props.addEnabled ? (
      <ModalTrigger modal={this.props.addModal}>
        <div className="ClassCardSection-addButton">
          <div className="ClassCardSection-addButtonContainer">
            <AddButton className="UserProfileView-addClassButton" />
            <div className="ClassCardSection-addButtonTitle">
              {this.props.addText}
            </div>
          </div>
        </div>
      </ModalTrigger>
    ) : null;
  }

  render() {
    const cards = this.props.items.map(item => <ClassCardView key={item.id} group={item} />);
    return (
      <Fieldset>
        <Legend>
          {this.props.label}
        </Legend>
        <div className="ClassCardSection">
          {cards}
          {this.renderAddButton()}
        </div>
      </Fieldset>
    );
  }
}

export default ClassCardSection;



// WEBPACK FOOTER //
// ./src/settings/components/ClassCardSection.jsx